import { RefiAlert } from './alert.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';
import '../../lit-element.js';
import '../../styles/reset.style.js';

defineRefiElement('refi-common-alert', RefiAlert);
